module.exports = __webpack_public_path__ + "img/1513861040.070e1441.jpg";